// Footer menu slideToggle
let slideUp = (target, duration=500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      //alert("!");
    }, duration);
  }

  let slideDown = (target, duration=500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
      display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  var slideToggle = (selector, target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
      selector.classList.add("is--visible");
      return slideDown(target, duration);
    } else {
      selector.classList.remove("is--visible");
      return slideUp(target, duration);
    }
  }


const menuToggle = document.querySelectorAll(".footer__block--links");

menuToggle.forEach((menuItem) => {
  menuItem.querySelector('p').addEventListener('click', function(e) {
    slideToggle(e.target, menuItem.querySelector("ul"), 200);
  });
});



// Check products and collections page and hide instagram block
function isCurrentUrlStartingWith(searchString) {

    const currentUrl = window.location.href;
    if (!currentUrl || !searchString) {
        return false;
    }

    const lowercasedUrl = currentUrl.toLowerCase();
    const lowercasedSearchString = searchString.toLowerCase();

    return lowercasedUrl.startsWith(lowercasedSearchString);
}

const productString    = "https://baronefirenze.it/products";
const collectionString = "https://baronefirenze.it/collections/";

// Remove isntagram on product and category
if (isCurrentUrlStartingWith(productString) || isCurrentUrlStartingWith(collectionString)) {
  document.getElementById('shopify-section-sections--20055191683403__17004702620fa73440').style.display = 'none';
  document.getElementById('shopify-section-sections--20055191683403__e1df650f-bf8c-4978-99e0-ade42d3746e0').style.display = 'none';
}

// Remove Announcement bar on product
if (isCurrentUrlStartingWith(productString)){
    document.getElementById('shopify-section-sections--20055191748939__883294e6-79f5-4d56-b33d-ca5ccfb61623').style.display = 'none';
}

